'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIAbstractIllustration;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _uiImages = require('ui-images');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _omit = require('../utils/underscore/omit');

var _omit2 = _interopRequireDefault(_omit);

var _BrowserTest = require('../utils/BrowserTest');

var _UIImage = require('./UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function UIAbstractIllustration(props) {
  var className = props.className,
      disabled = props.disabled,
      name = props.name,
      _getImageUrlFromName = props._getImageUrlFromName,
      rest = _objectWithoutProperties(props, ['className', 'disabled', 'name', '_getImageUrlFromName']);

  if (process.env.NODE_ENV !== 'production') {
    if (props.height == null && props.width == null) {
      _devLogger2.default.warn({
        message: 'UIAbstractIllustration: Provide either width or height prop to ensure proper scaling.',
        key: 'UIAbstractIllustration-dimensions-none'
      });
    }
    if (props.height != null && props.width != null) {
      _devLogger2.default.warn({
        message: 'UIAbstractIllustration: Setting both width and height may not behave as expected.',
        key: 'UIAbstractIllustration-dimensions-both'
      });
    }
  }

  return _react2.default.createElement(_UIImage2.default, _extends({}, rest, {
    responsive: false,
    className: (0, _classnames2.default)(className, 'private-illustration', {
      'private-illustration--disabled': disabled
    }),
    objectFit: 'contain',
    src: _getImageUrlFromName(name)
  }));
}

UIAbstractIllustration.propTypes = _extends({}, (0, _omit2.default)(_UIImage2.default.propTypes, 'src', 'responsive'), {
  disabled: _propTypes2.default.bool,
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  name: _propTypes2.default.string,
  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  _getImageUrlFromName: _propTypes2.default.func.isRequired
});

UIAbstractIllustration.defaultProps = _extends({}, (0, _omit2.default)(_UIImage2.default.defaultProps, 'responsive'), {
  _getImageUrlFromName: function _getImageUrlFromName(name) {
    return (0, _uiImages.getImageUrl)(name, undefined, (0, _BrowserTest.isIE11)());
  }
});

UIAbstractIllustration.displayName = 'UIAbstractIllustration';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/image/UIAbstractIllustration.js
// module id = 509
// module chunks = 177